import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['assigneesSelect']

  toggleAssigneesSelectVisibility(event) {
    const hideAssigneeSelect = !event.currentTarget.checked
    this.assigneesSelectTarget.classList.toggle('hidden', hideAssigneeSelect)
  }
}
